import React from 'react';
import { string, bool, arrayOf, shape, func } from 'prop-types';

import Item from './item';

const List = ({
  labelDefaultTag,
  labelBtnUseThisAddress,
  labelBtnCurrentlySelected,

  items,
  endpoints,
  showAddNewLink,
  cartId,

  onIsLoading
}) => {
  const propsItem = {
    labelDefaultTag,
    labelBtnUseThisAddress,
    labelBtnCurrentlySelected,
    showAddNewLink,
    cartId,
    endpoints,

    onIsLoading
  }; //propsItem

  return (
    <div className="change-address__list">
      {items?.map((item, index) => (
        <Item {...{ ...propsItem, item }} key={index} />
      ))}
    </div>
  );
};

List.propType = {
  labelDefaultTag: string.isRequired,
  labelBtnUseThisAddress: string.isRequired,
  labelBtnCurrentlySelected: string.isRequired,

  items: arrayOf(
    shape({
      isDefault: bool.isRequired,
      isSelected: bool.isRequired,
      id: string.isRequired,
      bsl: shape({
        label: string,
        icon: string
      }).isRequired,
      addressInfo: arrayOf(string)
    }).isRequired
  ),
  endpoints: shape({}),
  showAddNewLink: bool.isRequired,
  cartId: string,

  onIsLoading: func.isRequired
};

export default List;
